export default [
  {
    "id": 99884934,
    "node_id": "MDEwOlJlcG9zaXRvcnk5OTg4NDkzNA==",
    "name": "angular-education",
    "full_name": "mosh-hamedani/angular-education",
    "private": false,
    "owner": {
      "login": "mosh-hamedani",
      "id": 5441280,
      "node_id": "MDQ6VXNlcjU0NDEyODA=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/5441280?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/mosh-hamedani",
      "html_url": "https://github.com/mosh-hamedani",
      "followers_url": "https://api.github.com/users/mosh-hamedani/followers",
      "following_url": "https://api.github.com/users/mosh-hamedani/following{/other_user}",
      "gists_url": "https://api.github.com/users/mosh-hamedani/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/mosh-hamedani/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/mosh-hamedani/subscriptions",
      "organizations_url": "https://api.github.com/users/mosh-hamedani/orgs",
      "repos_url": "https://api.github.com/users/mosh-hamedani/repos",
      "events_url": "https://api.github.com/users/mosh-hamedani/events{/privacy}",
      "received_events_url": "https://api.github.com/users/mosh-hamedani/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/mosh-hamedani/angular-education",
    "description": "A list of helpful material to develop using Angular",
    "fork": true,
    "url": "https://api.github.com/repos/mosh-hamedani/angular-education",
    "forks_url": "https://api.github.com/repos/mosh-hamedani/angular-education/forks",
    "keys_url": "https://api.github.com/repos/mosh-hamedani/angular-education/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/mosh-hamedani/angular-education/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/mosh-hamedani/angular-education/teams",
    "hooks_url": "https://api.github.com/repos/mosh-hamedani/angular-education/hooks",
    "issue_events_url": "https://api.github.com/repos/mosh-hamedani/angular-education/issues/events{/number}",
    "events_url": "https://api.github.com/repos/mosh-hamedani/angular-education/events",
    "assignees_url": "https://api.github.com/repos/mosh-hamedani/angular-education/assignees{/user}",
    "branches_url": "https://api.github.com/repos/mosh-hamedani/angular-education/branches{/branch}",
    "tags_url": "https://api.github.com/repos/mosh-hamedani/angular-education/tags",
    "blobs_url": "https://api.github.com/repos/mosh-hamedani/angular-education/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/mosh-hamedani/angular-education/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/mosh-hamedani/angular-education/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/mosh-hamedani/angular-education/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/mosh-hamedani/angular-education/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/mosh-hamedani/angular-education/languages",
    "stargazers_url": "https://api.github.com/repos/mosh-hamedani/angular-education/stargazers",
    "contributors_url": "https://api.github.com/repos/mosh-hamedani/angular-education/contributors",
    "subscribers_url": "https://api.github.com/repos/mosh-hamedani/angular-education/subscribers",
    "subscription_url": "https://api.github.com/repos/mosh-hamedani/angular-education/subscription",
    "commits_url": "https://api.github.com/repos/mosh-hamedani/angular-education/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/mosh-hamedani/angular-education/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/mosh-hamedani/angular-education/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/mosh-hamedani/angular-education/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/mosh-hamedani/angular-education/contents/{+path}",
    "compare_url": "https://api.github.com/repos/mosh-hamedani/angular-education/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/mosh-hamedani/angular-education/merges",
    "archive_url": "https://api.github.com/repos/mosh-hamedani/angular-education/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/mosh-hamedani/angular-education/downloads",
    "issues_url": "https://api.github.com/repos/mosh-hamedani/angular-education/issues{/number}",
    "pulls_url": "https://api.github.com/repos/mosh-hamedani/angular-education/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/mosh-hamedani/angular-education/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/mosh-hamedani/angular-education/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/mosh-hamedani/angular-education/labels{/name}",
    "releases_url": "https://api.github.com/repos/mosh-hamedani/angular-education/releases{/id}",
    "deployments_url": "https://api.github.com/repos/mosh-hamedani/angular-education/deployments",
    "created_at": "2017-08-10T05:30:30Z",
    "updated_at": "2020-11-16T22:06:12Z",
    "pushed_at": "2017-08-10T05:36:38Z",
    "git_url": "git://github.com/mosh-hamedani/angular-education.git",
    "ssh_url": "git@github.com:mosh-hamedani/angular-education.git",
    "clone_url": "https://github.com/mosh-hamedani/angular-education.git",
    "svn_url": "https://github.com/mosh-hamedani/angular-education",
    "homepage": "",
    "size": 204,
    "stargazers_count": 13,
    "watchers_count": 13,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 28,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 28,
    "open_issues": 0,
    "watchers": 13,
    "default_branch": "master"
  },
  {
    "id": 51791917,
    "node_id": "MDEwOlJlcG9zaXRvcnk1MTc5MTkxNw==",
    "name": "angular2-course",
    "full_name": "mosh-hamedani/angular2-course",
    "private": false,
    "owner": {
      "login": "mosh-hamedani",
      "id": 5441280,
      "node_id": "MDQ6VXNlcjU0NDEyODA=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/5441280?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/mosh-hamedani",
      "html_url": "https://github.com/mosh-hamedani",
      "followers_url": "https://api.github.com/users/mosh-hamedani/followers",
      "following_url": "https://api.github.com/users/mosh-hamedani/following{/other_user}",
      "gists_url": "https://api.github.com/users/mosh-hamedani/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/mosh-hamedani/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/mosh-hamedani/subscriptions",
      "organizations_url": "https://api.github.com/users/mosh-hamedani/orgs",
      "repos_url": "https://api.github.com/users/mosh-hamedani/repos",
      "events_url": "https://api.github.com/users/mosh-hamedani/events{/privacy}",
      "received_events_url": "https://api.github.com/users/mosh-hamedani/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/mosh-hamedani/angular2-course",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/mosh-hamedani/angular2-course",
    "forks_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/forks",
    "keys_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/teams",
    "hooks_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/hooks",
    "issue_events_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/issues/events{/number}",
    "events_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/events",
    "assignees_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/assignees{/user}",
    "branches_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/branches{/branch}",
    "tags_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/tags",
    "blobs_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/languages",
    "stargazers_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/stargazers",
    "contributors_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/contributors",
    "subscribers_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/subscribers",
    "subscription_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/subscription",
    "commits_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/contents/{+path}",
    "compare_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/merges",
    "archive_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/downloads",
    "issues_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/issues{/number}",
    "pulls_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/labels{/name}",
    "releases_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/releases{/id}",
    "deployments_url": "https://api.github.com/repos/mosh-hamedani/angular2-course/deployments",
    "created_at": "2016-02-15T22:59:37Z",
    "updated_at": "2020-11-06T06:20:28Z",
    "pushed_at": "2016-12-23T14:50:12Z",
    "git_url": "git://github.com/mosh-hamedani/angular2-course.git",
    "ssh_url": "git@github.com:mosh-hamedani/angular2-course.git",
    "clone_url": "https://github.com/mosh-hamedani/angular2-course.git",
    "svn_url": "https://github.com/mosh-hamedani/angular2-course",
    "homepage": null,
    "size": 670,
    "stargazers_count": 123,
    "watchers_count": 123,
    "language": "TypeScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 101,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 15,
    "license": null,
    "forks": 101,
    "open_issues": 15,
    "watchers": 123,
    "default_branch": "master"
  },
  {
    "id": 67458388,
    "node_id": "MDEwOlJlcG9zaXRvcnk2NzQ1ODM4OA==",
    "name": "angularfire2",
    "full_name": "mosh-hamedani/angularfire2",
    "private": false,
    "owner": {
      "login": "mosh-hamedani",
      "id": 5441280,
      "node_id": "MDQ6VXNlcjU0NDEyODA=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/5441280?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/mosh-hamedani",
      "html_url": "https://github.com/mosh-hamedani",
      "followers_url": "https://api.github.com/users/mosh-hamedani/followers",
      "following_url": "https://api.github.com/users/mosh-hamedani/following{/other_user}",
      "gists_url": "https://api.github.com/users/mosh-hamedani/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/mosh-hamedani/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/mosh-hamedani/subscriptions",
      "organizations_url": "https://api.github.com/users/mosh-hamedani/orgs",
      "repos_url": "https://api.github.com/users/mosh-hamedani/repos",
      "events_url": "https://api.github.com/users/mosh-hamedani/events{/privacy}",
      "received_events_url": "https://api.github.com/users/mosh-hamedani/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/mosh-hamedani/angularfire2",
    "description": "The official Angular 2 library for Firebase.",
    "fork": true,
    "url": "https://api.github.com/repos/mosh-hamedani/angularfire2",
    "forks_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/forks",
    "keys_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/teams",
    "hooks_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/hooks",
    "issue_events_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/issues/events{/number}",
    "events_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/events",
    "assignees_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/assignees{/user}",
    "branches_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/branches{/branch}",
    "tags_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/tags",
    "blobs_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/languages",
    "stargazers_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/stargazers",
    "contributors_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/contributors",
    "subscribers_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/subscribers",
    "subscription_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/subscription",
    "commits_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/contents/{+path}",
    "compare_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/merges",
    "archive_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/downloads",
    "issues_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/issues{/number}",
    "pulls_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/labels{/name}",
    "releases_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/releases{/id}",
    "deployments_url": "https://api.github.com/repos/mosh-hamedani/angularfire2/deployments",
    "created_at": "2016-09-06T00:06:45Z",
    "updated_at": "2020-11-16T22:06:01Z",
    "pushed_at": "2016-09-04T15:46:24Z",
    "git_url": "git://github.com/mosh-hamedani/angularfire2.git",
    "ssh_url": "git@github.com:mosh-hamedani/angularfire2.git",
    "clone_url": "https://github.com/mosh-hamedani/angularfire2.git",
    "svn_url": "https://github.com/mosh-hamedani/angularfire2",
    "homepage": "https://angularfire2.com",
    "size": 471,
    "stargazers_count": 6,
    "watchers_count": 6,
    "language": "TypeScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 12,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 12,
    "open_issues": 0,
    "watchers": 6,
    "default_branch": "master"
  },
  {
    "id": 99885624,
    "node_id": "MDEwOlJlcG9zaXRvcnk5OTg4NTYyNA==",
    "name": "AngularJS2-Learning",
    "full_name": "mosh-hamedani/AngularJS2-Learning",
    "private": false,
    "owner": {
      "login": "mosh-hamedani",
      "id": 5441280,
      "node_id": "MDQ6VXNlcjU0NDEyODA=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/5441280?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/mosh-hamedani",
      "html_url": "https://github.com/mosh-hamedani",
      "followers_url": "https://api.github.com/users/mosh-hamedani/followers",
      "following_url": "https://api.github.com/users/mosh-hamedani/following{/other_user}",
      "gists_url": "https://api.github.com/users/mosh-hamedani/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/mosh-hamedani/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/mosh-hamedani/subscriptions",
      "organizations_url": "https://api.github.com/users/mosh-hamedani/orgs",
      "repos_url": "https://api.github.com/users/mosh-hamedani/repos",
      "events_url": "https://api.github.com/users/mosh-hamedani/events{/privacy}",
      "received_events_url": "https://api.github.com/users/mosh-hamedani/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/mosh-hamedani/AngularJS2-Learning",
    "description": "A list of resources for learning Angular2",
    "fork": true,
    "url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning",
    "forks_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/forks",
    "keys_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/teams",
    "hooks_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/hooks",
    "issue_events_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/issues/events{/number}",
    "events_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/events",
    "assignees_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/assignees{/user}",
    "branches_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/branches{/branch}",
    "tags_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/tags",
    "blobs_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/languages",
    "stargazers_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/stargazers",
    "contributors_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/contributors",
    "subscribers_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/subscribers",
    "subscription_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/subscription",
    "commits_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/contents/{+path}",
    "compare_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/merges",
    "archive_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/downloads",
    "issues_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/issues{/number}",
    "pulls_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/labels{/name}",
    "releases_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/releases{/id}",
    "deployments_url": "https://api.github.com/repos/mosh-hamedani/AngularJS2-Learning/deployments",
    "created_at": "2017-08-10T05:41:03Z",
    "updated_at": "2020-11-16T22:06:14Z",
    "pushed_at": "2017-08-10T05:42:13Z",
    "git_url": "git://github.com/mosh-hamedani/AngularJS2-Learning.git",
    "ssh_url": "git@github.com:mosh-hamedani/AngularJS2-Learning.git",
    "clone_url": "https://github.com/mosh-hamedani/AngularJS2-Learning.git",
    "svn_url": "https://github.com/mosh-hamedani/AngularJS2-Learning",
    "homepage": null,
    "size": 25,
    "stargazers_count": 17,
    "watchers_count": 17,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 14,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 14,
    "open_issues": 0,
    "watchers": 17,
    "default_branch": "master"
  },
  {
    "id": 99885926,
    "node_id": "MDEwOlJlcG9zaXRvcnk5OTg4NTkyNg==",
    "name": "awesome-angular",
    "full_name": "mosh-hamedani/awesome-angular",
    "private": false,
    "owner": {
      "login": "mosh-hamedani",
      "id": 5441280,
      "node_id": "MDQ6VXNlcjU0NDEyODA=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/5441280?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/mosh-hamedani",
      "html_url": "https://github.com/mosh-hamedani",
      "followers_url": "https://api.github.com/users/mosh-hamedani/followers",
      "following_url": "https://api.github.com/users/mosh-hamedani/following{/other_user}",
      "gists_url": "https://api.github.com/users/mosh-hamedani/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/mosh-hamedani/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/mosh-hamedani/subscriptions",
      "organizations_url": "https://api.github.com/users/mosh-hamedani/orgs",
      "repos_url": "https://api.github.com/users/mosh-hamedani/repos",
      "events_url": "https://api.github.com/users/mosh-hamedani/events{/privacy}",
      "received_events_url": "https://api.github.com/users/mosh-hamedani/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/mosh-hamedani/awesome-angular",
    "description": ":page_facing_up: A curated list of awesome Angular resources by @AngularClass a @OneSpeed-io company",
    "fork": true,
    "url": "https://api.github.com/repos/mosh-hamedani/awesome-angular",
    "forks_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/forks",
    "keys_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/teams",
    "hooks_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/hooks",
    "issue_events_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/issues/events{/number}",
    "events_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/events",
    "assignees_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/assignees{/user}",
    "branches_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/branches{/branch}",
    "tags_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/tags",
    "blobs_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/languages",
    "stargazers_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/stargazers",
    "contributors_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/contributors",
    "subscribers_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/subscribers",
    "subscription_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/subscription",
    "commits_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/contents/{+path}",
    "compare_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/merges",
    "archive_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/downloads",
    "issues_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/issues{/number}",
    "pulls_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/labels{/name}",
    "releases_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/releases{/id}",
    "deployments_url": "https://api.github.com/repos/mosh-hamedani/awesome-angular/deployments",
    "created_at": "2017-08-10T05:45:49Z",
    "updated_at": "2020-11-16T22:06:16Z",
    "pushed_at": "2017-08-10T05:49:30Z",
    "git_url": "git://github.com/mosh-hamedani/awesome-angular.git",
    "ssh_url": "git@github.com:mosh-hamedani/awesome-angular.git",
    "clone_url": "https://github.com/mosh-hamedani/awesome-angular.git",
    "svn_url": "https://github.com/mosh-hamedani/awesome-angular",
    "homepage": "http://bit.ly/angular-class",
    "size": 573,
    "stargazers_count": 26,
    "watchers_count": 26,
    "language": "HTML",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 26,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "cc0-1.0",
      "name": "Creative Commons Zero v1.0 Universal",
      "spdx_id": "CC0-1.0",
      "url": "https://api.github.com/licenses/cc0-1.0",
      "node_id": "MDc6TGljZW5zZTY="
    },
    "forks": 26,
    "open_issues": 0,
    "watchers": 26,
    "default_branch": "gh-pages"
  },
  {
    "id": 106336700,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMDYzMzY3MDA=",
    "name": "codewithmosh",
    "full_name": "mosh-hamedani/codewithmosh",
    "private": false,
    "owner": {
      "login": "mosh-hamedani",
      "id": 5441280,
      "node_id": "MDQ6VXNlcjU0NDEyODA=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/5441280?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/mosh-hamedani",
      "html_url": "https://github.com/mosh-hamedani",
      "followers_url": "https://api.github.com/users/mosh-hamedani/followers",
      "following_url": "https://api.github.com/users/mosh-hamedani/following{/other_user}",
      "gists_url": "https://api.github.com/users/mosh-hamedani/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/mosh-hamedani/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/mosh-hamedani/subscriptions",
      "organizations_url": "https://api.github.com/users/mosh-hamedani/orgs",
      "repos_url": "https://api.github.com/users/mosh-hamedani/repos",
      "events_url": "https://api.github.com/users/mosh-hamedani/events{/privacy}",
      "received_events_url": "https://api.github.com/users/mosh-hamedani/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/mosh-hamedani/codewithmosh",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/mosh-hamedani/codewithmosh",
    "forks_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/forks",
    "keys_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/teams",
    "hooks_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/hooks",
    "issue_events_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/issues/events{/number}",
    "events_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/events",
    "assignees_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/assignees{/user}",
    "branches_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/branches{/branch}",
    "tags_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/tags",
    "blobs_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/languages",
    "stargazers_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/stargazers",
    "contributors_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/contributors",
    "subscribers_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/subscribers",
    "subscription_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/subscription",
    "commits_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/contents/{+path}",
    "compare_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/merges",
    "archive_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/downloads",
    "issues_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/issues{/number}",
    "pulls_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/labels{/name}",
    "releases_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/releases{/id}",
    "deployments_url": "https://api.github.com/repos/mosh-hamedani/codewithmosh/deployments",
    "created_at": "2017-10-09T21:21:32Z",
    "updated_at": "2020-11-16T22:06:19Z",
    "pushed_at": "2017-10-18T17:58:21Z",
    "git_url": "git://github.com/mosh-hamedani/codewithmosh.git",
    "ssh_url": "git@github.com:mosh-hamedani/codewithmosh.git",
    "clone_url": "https://github.com/mosh-hamedani/codewithmosh.git",
    "svn_url": "https://github.com/mosh-hamedani/codewithmosh",
    "homepage": null,
    "size": 2152,
    "stargazers_count": 17,
    "watchers_count": 17,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 8,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 8,
    "open_issues": 0,
    "watchers": 17,
    "default_branch": "master"
  },
  {
    "id": 98351671,
    "node_id": "MDEwOlJlcG9zaXRvcnk5ODM1MTY3MQ==",
    "name": "followers-app",
    "full_name": "mosh-hamedani/followers-app",
    "private": false,
    "owner": {
      "login": "mosh-hamedani",
      "id": 5441280,
      "node_id": "MDQ6VXNlcjU0NDEyODA=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/5441280?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/mosh-hamedani",
      "html_url": "https://github.com/mosh-hamedani",
      "followers_url": "https://api.github.com/users/mosh-hamedani/followers",
      "following_url": "https://api.github.com/users/mosh-hamedani/following{/other_user}",
      "gists_url": "https://api.github.com/users/mosh-hamedani/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/mosh-hamedani/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/mosh-hamedani/subscriptions",
      "organizations_url": "https://api.github.com/users/mosh-hamedani/orgs",
      "repos_url": "https://api.github.com/users/mosh-hamedani/repos",
      "events_url": "https://api.github.com/users/mosh-hamedani/events{/privacy}",
      "received_events_url": "https://api.github.com/users/mosh-hamedani/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/mosh-hamedani/followers-app",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/mosh-hamedani/followers-app",
    "forks_url": "https://api.github.com/repos/mosh-hamedani/followers-app/forks",
    "keys_url": "https://api.github.com/repos/mosh-hamedani/followers-app/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/mosh-hamedani/followers-app/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/mosh-hamedani/followers-app/teams",
    "hooks_url": "https://api.github.com/repos/mosh-hamedani/followers-app/hooks",
    "issue_events_url": "https://api.github.com/repos/mosh-hamedani/followers-app/issues/events{/number}",
    "events_url": "https://api.github.com/repos/mosh-hamedani/followers-app/events",
    "assignees_url": "https://api.github.com/repos/mosh-hamedani/followers-app/assignees{/user}",
    "branches_url": "https://api.github.com/repos/mosh-hamedani/followers-app/branches{/branch}",
    "tags_url": "https://api.github.com/repos/mosh-hamedani/followers-app/tags",
    "blobs_url": "https://api.github.com/repos/mosh-hamedani/followers-app/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/mosh-hamedani/followers-app/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/mosh-hamedani/followers-app/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/mosh-hamedani/followers-app/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/mosh-hamedani/followers-app/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/mosh-hamedani/followers-app/languages",
    "stargazers_url": "https://api.github.com/repos/mosh-hamedani/followers-app/stargazers",
    "contributors_url": "https://api.github.com/repos/mosh-hamedani/followers-app/contributors",
    "subscribers_url": "https://api.github.com/repos/mosh-hamedani/followers-app/subscribers",
    "subscription_url": "https://api.github.com/repos/mosh-hamedani/followers-app/subscription",
    "commits_url": "https://api.github.com/repos/mosh-hamedani/followers-app/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/mosh-hamedani/followers-app/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/mosh-hamedani/followers-app/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/mosh-hamedani/followers-app/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/mosh-hamedani/followers-app/contents/{+path}",
    "compare_url": "https://api.github.com/repos/mosh-hamedani/followers-app/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/mosh-hamedani/followers-app/merges",
    "archive_url": "https://api.github.com/repos/mosh-hamedani/followers-app/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/mosh-hamedani/followers-app/downloads",
    "issues_url": "https://api.github.com/repos/mosh-hamedani/followers-app/issues{/number}",
    "pulls_url": "https://api.github.com/repos/mosh-hamedani/followers-app/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/mosh-hamedani/followers-app/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/mosh-hamedani/followers-app/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/mosh-hamedani/followers-app/labels{/name}",
    "releases_url": "https://api.github.com/repos/mosh-hamedani/followers-app/releases{/id}",
    "deployments_url": "https://api.github.com/repos/mosh-hamedani/followers-app/deployments",
    "created_at": "2017-07-25T21:30:16Z",
    "updated_at": "2020-11-16T22:06:07Z",
    "pushed_at": "2017-07-25T21:45:45Z",
    "git_url": "git://github.com/mosh-hamedani/followers-app.git",
    "ssh_url": "git@github.com:mosh-hamedani/followers-app.git",
    "clone_url": "https://github.com/mosh-hamedani/followers-app.git",
    "svn_url": "https://github.com/mosh-hamedani/followers-app",
    "homepage": null,
    "size": 251,
    "stargazers_count": 7,
    "watchers_count": 7,
    "language": "TypeScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 7,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 7,
    "open_issues": 0,
    "watchers": 7,
    "default_branch": "master"
  },
  {
    "id": 293638287,
    "node_id": "MDEwOlJlcG9zaXRvcnkyOTM2MzgyODc=",
    "name": "jupiter",
    "full_name": "mosh-hamedani/jupiter",
    "private": false,
    "owner": {
      "login": "mosh-hamedani",
      "id": 5441280,
      "node_id": "MDQ6VXNlcjU0NDEyODA=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/5441280?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/mosh-hamedani",
      "html_url": "https://github.com/mosh-hamedani",
      "followers_url": "https://api.github.com/users/mosh-hamedani/followers",
      "following_url": "https://api.github.com/users/mosh-hamedani/following{/other_user}",
      "gists_url": "https://api.github.com/users/mosh-hamedani/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/mosh-hamedani/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/mosh-hamedani/subscriptions",
      "organizations_url": "https://api.github.com/users/mosh-hamedani/orgs",
      "repos_url": "https://api.github.com/users/mosh-hamedani/repos",
      "events_url": "https://api.github.com/users/mosh-hamedani/events{/privacy}",
      "received_events_url": "https://api.github.com/users/mosh-hamedani/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/mosh-hamedani/jupiter",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/mosh-hamedani/jupiter",
    "forks_url": "https://api.github.com/repos/mosh-hamedani/jupiter/forks",
    "keys_url": "https://api.github.com/repos/mosh-hamedani/jupiter/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/mosh-hamedani/jupiter/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/mosh-hamedani/jupiter/teams",
    "hooks_url": "https://api.github.com/repos/mosh-hamedani/jupiter/hooks",
    "issue_events_url": "https://api.github.com/repos/mosh-hamedani/jupiter/issues/events{/number}",
    "events_url": "https://api.github.com/repos/mosh-hamedani/jupiter/events",
    "assignees_url": "https://api.github.com/repos/mosh-hamedani/jupiter/assignees{/user}",
    "branches_url": "https://api.github.com/repos/mosh-hamedani/jupiter/branches{/branch}",
    "tags_url": "https://api.github.com/repos/mosh-hamedani/jupiter/tags",
    "blobs_url": "https://api.github.com/repos/mosh-hamedani/jupiter/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/mosh-hamedani/jupiter/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/mosh-hamedani/jupiter/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/mosh-hamedani/jupiter/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/mosh-hamedani/jupiter/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/mosh-hamedani/jupiter/languages",
    "stargazers_url": "https://api.github.com/repos/mosh-hamedani/jupiter/stargazers",
    "contributors_url": "https://api.github.com/repos/mosh-hamedani/jupiter/contributors",
    "subscribers_url": "https://api.github.com/repos/mosh-hamedani/jupiter/subscribers",
    "subscription_url": "https://api.github.com/repos/mosh-hamedani/jupiter/subscription",
    "commits_url": "https://api.github.com/repos/mosh-hamedani/jupiter/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/mosh-hamedani/jupiter/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/mosh-hamedani/jupiter/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/mosh-hamedani/jupiter/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/mosh-hamedani/jupiter/contents/{+path}",
    "compare_url": "https://api.github.com/repos/mosh-hamedani/jupiter/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/mosh-hamedani/jupiter/merges",
    "archive_url": "https://api.github.com/repos/mosh-hamedani/jupiter/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/mosh-hamedani/jupiter/downloads",
    "issues_url": "https://api.github.com/repos/mosh-hamedani/jupiter/issues{/number}",
    "pulls_url": "https://api.github.com/repos/mosh-hamedani/jupiter/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/mosh-hamedani/jupiter/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/mosh-hamedani/jupiter/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/mosh-hamedani/jupiter/labels{/name}",
    "releases_url": "https://api.github.com/repos/mosh-hamedani/jupiter/releases{/id}",
    "deployments_url": "https://api.github.com/repos/mosh-hamedani/jupiter/deployments",
    "created_at": "2020-09-07T21:43:37Z",
    "updated_at": "2020-11-16T22:06:24Z",
    "pushed_at": "2020-08-28T18:51:12Z",
    "git_url": "git://github.com/mosh-hamedani/jupiter.git",
    "ssh_url": "git@github.com:mosh-hamedani/jupiter.git",
    "clone_url": "https://github.com/mosh-hamedani/jupiter.git",
    "svn_url": "https://github.com/mosh-hamedani/jupiter",
    "homepage": null,
    "size": 4,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "master"
  },
  {
    "id": 98256836,
    "node_id": "MDEwOlJlcG9zaXRvcnk5ODI1NjgzNg==",
    "name": "mosh-hamedani.github.io",
    "full_name": "mosh-hamedani/mosh-hamedani.github.io",
    "private": false,
    "owner": {
      "login": "mosh-hamedani",
      "id": 5441280,
      "node_id": "MDQ6VXNlcjU0NDEyODA=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/5441280?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/mosh-hamedani",
      "html_url": "https://github.com/mosh-hamedani",
      "followers_url": "https://api.github.com/users/mosh-hamedani/followers",
      "following_url": "https://api.github.com/users/mosh-hamedani/following{/other_user}",
      "gists_url": "https://api.github.com/users/mosh-hamedani/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/mosh-hamedani/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/mosh-hamedani/subscriptions",
      "organizations_url": "https://api.github.com/users/mosh-hamedani/orgs",
      "repos_url": "https://api.github.com/users/mosh-hamedani/repos",
      "events_url": "https://api.github.com/users/mosh-hamedani/events{/privacy}",
      "received_events_url": "https://api.github.com/users/mosh-hamedani/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/mosh-hamedani/mosh-hamedani.github.io",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io",
    "forks_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/forks",
    "keys_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/teams",
    "hooks_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/hooks",
    "issue_events_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/issues/events{/number}",
    "events_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/events",
    "assignees_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/assignees{/user}",
    "branches_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/branches{/branch}",
    "tags_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/tags",
    "blobs_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/languages",
    "stargazers_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/stargazers",
    "contributors_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/contributors",
    "subscribers_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/subscribers",
    "subscription_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/subscription",
    "commits_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/contents/{+path}",
    "compare_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/merges",
    "archive_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/downloads",
    "issues_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/issues{/number}",
    "pulls_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/labels{/name}",
    "releases_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/releases{/id}",
    "deployments_url": "https://api.github.com/repos/mosh-hamedani/mosh-hamedani.github.io/deployments",
    "created_at": "2017-07-25T02:48:21Z",
    "updated_at": "2020-11-16T22:06:03Z",
    "pushed_at": "2017-07-25T03:00:57Z",
    "git_url": "git://github.com/mosh-hamedani/mosh-hamedani.github.io.git",
    "ssh_url": "git@github.com:mosh-hamedani/mosh-hamedani.github.io.git",
    "clone_url": "https://github.com/mosh-hamedani/mosh-hamedani.github.io.git",
    "svn_url": "https://github.com/mosh-hamedani/mosh-hamedani.github.io",
    "homepage": null,
    "size": 88,
    "stargazers_count": 6,
    "watchers_count": 6,
    "language": "TypeScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 3,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 3,
    "open_issues": 0,
    "watchers": 6,
    "default_branch": "master"
  },
  {
    "id": 101680905,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMDE2ODA5MDU=",
    "name": "organic-shop",
    "full_name": "mosh-hamedani/organic-shop",
    "private": false,
    "owner": {
      "login": "mosh-hamedani",
      "id": 5441280,
      "node_id": "MDQ6VXNlcjU0NDEyODA=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/5441280?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/mosh-hamedani",
      "html_url": "https://github.com/mosh-hamedani",
      "followers_url": "https://api.github.com/users/mosh-hamedani/followers",
      "following_url": "https://api.github.com/users/mosh-hamedani/following{/other_user}",
      "gists_url": "https://api.github.com/users/mosh-hamedani/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/mosh-hamedani/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/mosh-hamedani/subscriptions",
      "organizations_url": "https://api.github.com/users/mosh-hamedani/orgs",
      "repos_url": "https://api.github.com/users/mosh-hamedani/repos",
      "events_url": "https://api.github.com/users/mosh-hamedani/events{/privacy}",
      "received_events_url": "https://api.github.com/users/mosh-hamedani/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/mosh-hamedani/organic-shop",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/mosh-hamedani/organic-shop",
    "forks_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/forks",
    "keys_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/teams",
    "hooks_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/hooks",
    "issue_events_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/issues/events{/number}",
    "events_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/events",
    "assignees_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/assignees{/user}",
    "branches_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/branches{/branch}",
    "tags_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/tags",
    "blobs_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/languages",
    "stargazers_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/stargazers",
    "contributors_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/contributors",
    "subscribers_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/subscribers",
    "subscription_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/subscription",
    "commits_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/contents/{+path}",
    "compare_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/merges",
    "archive_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/downloads",
    "issues_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/issues{/number}",
    "pulls_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/labels{/name}",
    "releases_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/releases{/id}",
    "deployments_url": "https://api.github.com/repos/mosh-hamedani/organic-shop/deployments",
    "created_at": "2017-08-28T19:40:23Z",
    "updated_at": "2020-11-27T13:52:43Z",
    "pushed_at": "2017-09-09T02:45:48Z",
    "git_url": "git://github.com/mosh-hamedani/organic-shop.git",
    "ssh_url": "git@github.com:mosh-hamedani/organic-shop.git",
    "clone_url": "https://github.com/mosh-hamedani/organic-shop.git",
    "svn_url": "https://github.com/mosh-hamedani/organic-shop",
    "homepage": null,
    "size": 153,
    "stargazers_count": 152,
    "watchers_count": 152,
    "language": "TypeScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 161,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 15,
    "license": null,
    "forks": 161,
    "open_issues": 15,
    "watchers": 152,
    "default_branch": "master"
  },
  {
    "id": 30401858,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMDQwMTg1OA==",
    "name": "udemy-backbonejs-tutorial",
    "full_name": "mosh-hamedani/udemy-backbonejs-tutorial",
    "private": false,
    "owner": {
      "login": "mosh-hamedani",
      "id": 5441280,
      "node_id": "MDQ6VXNlcjU0NDEyODA=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/5441280?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/mosh-hamedani",
      "html_url": "https://github.com/mosh-hamedani",
      "followers_url": "https://api.github.com/users/mosh-hamedani/followers",
      "following_url": "https://api.github.com/users/mosh-hamedani/following{/other_user}",
      "gists_url": "https://api.github.com/users/mosh-hamedani/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/mosh-hamedani/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/mosh-hamedani/subscriptions",
      "organizations_url": "https://api.github.com/users/mosh-hamedani/orgs",
      "repos_url": "https://api.github.com/users/mosh-hamedani/repos",
      "events_url": "https://api.github.com/users/mosh-hamedani/events{/privacy}",
      "received_events_url": "https://api.github.com/users/mosh-hamedani/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/mosh-hamedani/udemy-backbonejs-tutorial",
    "description": "Following along at https://www.udemy.com/backbonejs-tutorial",
    "fork": true,
    "url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial",
    "forks_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/forks",
    "keys_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/teams",
    "hooks_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/hooks",
    "issue_events_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/issues/events{/number}",
    "events_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/events",
    "assignees_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/assignees{/user}",
    "branches_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/branches{/branch}",
    "tags_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/tags",
    "blobs_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/languages",
    "stargazers_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/stargazers",
    "contributors_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/contributors",
    "subscribers_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/subscribers",
    "subscription_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/subscription",
    "commits_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/contents/{+path}",
    "compare_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/merges",
    "archive_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/downloads",
    "issues_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/issues{/number}",
    "pulls_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/labels{/name}",
    "releases_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/releases{/id}",
    "deployments_url": "https://api.github.com/repos/mosh-hamedani/udemy-backbonejs-tutorial/deployments",
    "created_at": "2015-02-06T08:07:20Z",
    "updated_at": "2020-11-16T22:06:00Z",
    "pushed_at": "2015-02-10T12:04:49Z",
    "git_url": "git://github.com/mosh-hamedani/udemy-backbonejs-tutorial.git",
    "ssh_url": "git@github.com:mosh-hamedani/udemy-backbonejs-tutorial.git",
    "clone_url": "https://github.com/mosh-hamedani/udemy-backbonejs-tutorial.git",
    "svn_url": "https://github.com/mosh-hamedani/udemy-backbonejs-tutorial",
    "homepage": null,
    "size": 174,
    "stargazers_count": 5,
    "watchers_count": 5,
    "language": "CSS",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 9,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 9,
    "open_issues": 0,
    "watchers": 5,
    "default_branch": "master"
  },
  {
    "id": 85770266,
    "node_id": "MDEwOlJlcG9zaXRvcnk4NTc3MDI2Ng==",
    "name": "vega",
    "full_name": "mosh-hamedani/vega",
    "private": false,
    "owner": {
      "login": "mosh-hamedani",
      "id": 5441280,
      "node_id": "MDQ6VXNlcjU0NDEyODA=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/5441280?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/mosh-hamedani",
      "html_url": "https://github.com/mosh-hamedani",
      "followers_url": "https://api.github.com/users/mosh-hamedani/followers",
      "following_url": "https://api.github.com/users/mosh-hamedani/following{/other_user}",
      "gists_url": "https://api.github.com/users/mosh-hamedani/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/mosh-hamedani/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/mosh-hamedani/subscriptions",
      "organizations_url": "https://api.github.com/users/mosh-hamedani/orgs",
      "repos_url": "https://api.github.com/users/mosh-hamedani/repos",
      "events_url": "https://api.github.com/users/mosh-hamedani/events{/privacy}",
      "received_events_url": "https://api.github.com/users/mosh-hamedani/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/mosh-hamedani/vega",
    "description": "A sample vehicle dealer app built with Angular 2, ASP.NET Core and Entity Framework Core. This is part of my Udemy course: \"Build a Real-world App with ASP.NET Core and Angular 2\".",
    "fork": false,
    "url": "https://api.github.com/repos/mosh-hamedani/vega",
    "forks_url": "https://api.github.com/repos/mosh-hamedani/vega/forks",
    "keys_url": "https://api.github.com/repos/mosh-hamedani/vega/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/mosh-hamedani/vega/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/mosh-hamedani/vega/teams",
    "hooks_url": "https://api.github.com/repos/mosh-hamedani/vega/hooks",
    "issue_events_url": "https://api.github.com/repos/mosh-hamedani/vega/issues/events{/number}",
    "events_url": "https://api.github.com/repos/mosh-hamedani/vega/events",
    "assignees_url": "https://api.github.com/repos/mosh-hamedani/vega/assignees{/user}",
    "branches_url": "https://api.github.com/repos/mosh-hamedani/vega/branches{/branch}",
    "tags_url": "https://api.github.com/repos/mosh-hamedani/vega/tags",
    "blobs_url": "https://api.github.com/repos/mosh-hamedani/vega/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/mosh-hamedani/vega/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/mosh-hamedani/vega/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/mosh-hamedani/vega/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/mosh-hamedani/vega/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/mosh-hamedani/vega/languages",
    "stargazers_url": "https://api.github.com/repos/mosh-hamedani/vega/stargazers",
    "contributors_url": "https://api.github.com/repos/mosh-hamedani/vega/contributors",
    "subscribers_url": "https://api.github.com/repos/mosh-hamedani/vega/subscribers",
    "subscription_url": "https://api.github.com/repos/mosh-hamedani/vega/subscription",
    "commits_url": "https://api.github.com/repos/mosh-hamedani/vega/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/mosh-hamedani/vega/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/mosh-hamedani/vega/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/mosh-hamedani/vega/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/mosh-hamedani/vega/contents/{+path}",
    "compare_url": "https://api.github.com/repos/mosh-hamedani/vega/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/mosh-hamedani/vega/merges",
    "archive_url": "https://api.github.com/repos/mosh-hamedani/vega/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/mosh-hamedani/vega/downloads",
    "issues_url": "https://api.github.com/repos/mosh-hamedani/vega/issues{/number}",
    "pulls_url": "https://api.github.com/repos/mosh-hamedani/vega/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/mosh-hamedani/vega/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/mosh-hamedani/vega/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/mosh-hamedani/vega/labels{/name}",
    "releases_url": "https://api.github.com/repos/mosh-hamedani/vega/releases{/id}",
    "deployments_url": "https://api.github.com/repos/mosh-hamedani/vega/deployments",
    "created_at": "2017-03-22T01:13:11Z",
    "updated_at": "2020-12-02T12:13:54Z",
    "pushed_at": "2020-08-19T21:21:10Z",
    "git_url": "git://github.com/mosh-hamedani/vega.git",
    "ssh_url": "git@github.com:mosh-hamedani/vega.git",
    "clone_url": "https://github.com/mosh-hamedani/vega.git",
    "svn_url": "https://github.com/mosh-hamedani/vega",
    "homepage": null,
    "size": 123,
    "stargazers_count": 127,
    "watchers_count": 127,
    "language": "C#",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 120,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 16,
    "license": null,
    "forks": 120,
    "open_issues": 16,
    "watchers": 127,
    "default_branch": "master"
  },
  {
    "id": 141628613,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDE2Mjg2MTM=",
    "name": "vidly-api-node",
    "full_name": "mosh-hamedani/vidly-api-node",
    "private": false,
    "owner": {
      "login": "mosh-hamedani",
      "id": 5441280,
      "node_id": "MDQ6VXNlcjU0NDEyODA=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/5441280?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/mosh-hamedani",
      "html_url": "https://github.com/mosh-hamedani",
      "followers_url": "https://api.github.com/users/mosh-hamedani/followers",
      "following_url": "https://api.github.com/users/mosh-hamedani/following{/other_user}",
      "gists_url": "https://api.github.com/users/mosh-hamedani/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/mosh-hamedani/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/mosh-hamedani/subscriptions",
      "organizations_url": "https://api.github.com/users/mosh-hamedani/orgs",
      "repos_url": "https://api.github.com/users/mosh-hamedani/repos",
      "events_url": "https://api.github.com/users/mosh-hamedani/events{/privacy}",
      "received_events_url": "https://api.github.com/users/mosh-hamedani/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/mosh-hamedani/vidly-api-node",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node",
    "forks_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/forks",
    "keys_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/teams",
    "hooks_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/hooks",
    "issue_events_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/issues/events{/number}",
    "events_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/events",
    "assignees_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/assignees{/user}",
    "branches_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/branches{/branch}",
    "tags_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/tags",
    "blobs_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/languages",
    "stargazers_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/stargazers",
    "contributors_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/contributors",
    "subscribers_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/subscribers",
    "subscription_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/subscription",
    "commits_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/contents/{+path}",
    "compare_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/merges",
    "archive_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/downloads",
    "issues_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/issues{/number}",
    "pulls_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/labels{/name}",
    "releases_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/releases{/id}",
    "deployments_url": "https://api.github.com/repos/mosh-hamedani/vidly-api-node/deployments",
    "created_at": "2018-07-19T20:39:41Z",
    "updated_at": "2020-11-28T11:16:41Z",
    "pushed_at": "2020-09-26T15:46:57Z",
    "git_url": "git://github.com/mosh-hamedani/vidly-api-node.git",
    "ssh_url": "git@github.com:mosh-hamedani/vidly-api-node.git",
    "clone_url": "https://github.com/mosh-hamedani/vidly-api-node.git",
    "svn_url": "https://github.com/mosh-hamedani/vidly-api-node",
    "homepage": null,
    "size": 68,
    "stargazers_count": 186,
    "watchers_count": 186,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 159,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 25,
    "license": null,
    "forks": 159,
    "open_issues": 25,
    "watchers": 186,
    "default_branch": "master"
  },
  {
    "id": 55126507,
    "node_id": "MDEwOlJlcG9zaXRvcnk1NTEyNjUwNw==",
    "name": "vidly-mvc-5",
    "full_name": "mosh-hamedani/vidly-mvc-5",
    "private": false,
    "owner": {
      "login": "mosh-hamedani",
      "id": 5441280,
      "node_id": "MDQ6VXNlcjU0NDEyODA=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/5441280?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/mosh-hamedani",
      "html_url": "https://github.com/mosh-hamedani",
      "followers_url": "https://api.github.com/users/mosh-hamedani/followers",
      "following_url": "https://api.github.com/users/mosh-hamedani/following{/other_user}",
      "gists_url": "https://api.github.com/users/mosh-hamedani/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/mosh-hamedani/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/mosh-hamedani/subscriptions",
      "organizations_url": "https://api.github.com/users/mosh-hamedani/orgs",
      "repos_url": "https://api.github.com/users/mosh-hamedani/repos",
      "events_url": "https://api.github.com/users/mosh-hamedani/events{/privacy}",
      "received_events_url": "https://api.github.com/users/mosh-hamedani/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/mosh-hamedani/vidly-mvc-5",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5",
    "forks_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/forks",
    "keys_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/teams",
    "hooks_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/hooks",
    "issue_events_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/issues/events{/number}",
    "events_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/events",
    "assignees_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/assignees{/user}",
    "branches_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/branches{/branch}",
    "tags_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/tags",
    "blobs_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/languages",
    "stargazers_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/stargazers",
    "contributors_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/contributors",
    "subscribers_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/subscribers",
    "subscription_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/subscription",
    "commits_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/contents/{+path}",
    "compare_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/merges",
    "archive_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/downloads",
    "issues_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/issues{/number}",
    "pulls_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/labels{/name}",
    "releases_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/releases{/id}",
    "deployments_url": "https://api.github.com/repos/mosh-hamedani/vidly-mvc-5/deployments",
    "created_at": "2016-03-31T06:37:00Z",
    "updated_at": "2020-12-02T21:03:58Z",
    "pushed_at": "2020-11-29T10:13:01Z",
    "git_url": "git://github.com/mosh-hamedani/vidly-mvc-5.git",
    "ssh_url": "git@github.com:mosh-hamedani/vidly-mvc-5.git",
    "clone_url": "https://github.com/mosh-hamedani/vidly-mvc-5.git",
    "svn_url": "https://github.com/mosh-hamedani/vidly-mvc-5",
    "homepage": null,
    "size": 1039,
    "stargazers_count": 731,
    "watchers_count": 731,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 1042,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 101,
    "license": null,
    "forks": 1042,
    "open_issues": 101,
    "watchers": 731,
    "default_branch": "master"
  },
  {
    "id": 98350374,
    "node_id": "MDEwOlJlcG9zaXRvcnk5ODM1MDM3NA==",
    "name": "xdeploy",
    "full_name": "mosh-hamedani/xdeploy",
    "private": false,
    "owner": {
      "login": "mosh-hamedani",
      "id": 5441280,
      "node_id": "MDQ6VXNlcjU0NDEyODA=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/5441280?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/mosh-hamedani",
      "html_url": "https://github.com/mosh-hamedani",
      "followers_url": "https://api.github.com/users/mosh-hamedani/followers",
      "following_url": "https://api.github.com/users/mosh-hamedani/following{/other_user}",
      "gists_url": "https://api.github.com/users/mosh-hamedani/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/mosh-hamedani/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/mosh-hamedani/subscriptions",
      "organizations_url": "https://api.github.com/users/mosh-hamedani/orgs",
      "repos_url": "https://api.github.com/users/mosh-hamedani/repos",
      "events_url": "https://api.github.com/users/mosh-hamedani/events{/privacy}",
      "received_events_url": "https://api.github.com/users/mosh-hamedani/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/mosh-hamedani/xdeploy",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/mosh-hamedani/xdeploy",
    "forks_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/forks",
    "keys_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/teams",
    "hooks_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/hooks",
    "issue_events_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/issues/events{/number}",
    "events_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/events",
    "assignees_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/assignees{/user}",
    "branches_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/branches{/branch}",
    "tags_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/tags",
    "blobs_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/languages",
    "stargazers_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/stargazers",
    "contributors_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/contributors",
    "subscribers_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/subscribers",
    "subscription_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/subscription",
    "commits_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/contents/{+path}",
    "compare_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/merges",
    "archive_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/downloads",
    "issues_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/issues{/number}",
    "pulls_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/labels{/name}",
    "releases_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/releases{/id}",
    "deployments_url": "https://api.github.com/repos/mosh-hamedani/xdeploy/deployments",
    "created_at": "2017-07-25T21:11:09Z",
    "updated_at": "2020-11-16T22:06:04Z",
    "pushed_at": "2017-07-25T21:20:24Z",
    "git_url": "git://github.com/mosh-hamedani/xdeploy.git",
    "ssh_url": "git@github.com:mosh-hamedani/xdeploy.git",
    "clone_url": "https://github.com/mosh-hamedani/xdeploy.git",
    "svn_url": "https://github.com/mosh-hamedani/xdeploy",
    "homepage": null,
    "size": 251,
    "stargazers_count": 2,
    "watchers_count": 2,
    "language": "TypeScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 3,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 3,
    "open_issues": 0,
    "watchers": 2,
    "default_branch": "master"
  }
]